import { render, staticRenderFns } from "./RemitWarrants.vue?vue&type=template&id=2c1b2792&"
import script from "./RemitWarrants.vue?vue&type=script&lang=js&"
export * from "./RemitWarrants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports